module.exports = __webpack_public_path__ + "img/team-chats-zero-state.2eb729b4.svg";